import { Col, Row, Typography } from "antd";
import XdLogo from "../../assets/XdLogo.svg";
import styles from "./reset-password-confirm.module.scss";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft, faCircleCheck } from '@fortawesome/free-solid-svg-icons';

const ResetPasswordConfirm: React.FC = () => {    
    
    return (
        <>
            <div className={styles.pageContainer}>
                <Row>
                    <Col xs={24} md={24} lg={24} className={styles.headerPage}>
                        <div className={styles.pageHeader}>
                            <span className={styles.xdLogo}>
                                <img
                                    src={XdLogo}
                                    alt="icon"
                                />
                            </span>
                        </div>
                    </Col>
                </Row>
                <Row className={styles.contentRow}>
                    <Col xs={24} md={24} lg={24} className={styles.resetPasswordConfirmPage}>
                        <div className={styles.resetPasswordHeader}>
                            <Typography.Title level={3} className={styles.successText}>
                                <FontAwesomeIcon style={{
                                                    color: 'green',
                                                    width: '24px',
                                                    height: '24px'
                                                }} 
                                                icon={faCircleCheck} 
                                />
                            </Typography.Title>
                            <Typography.Title level={3}>Password Successfully Updated</Typography.Title>
                            <Typography.Text style={{ color: '#99A0A7', fontWeight: 400 }}>
                                Log back in with your new password
                            </Typography.Text>
                            
                            <Typography.Title level={5} className={styles.backLink}>
                                <Typography.Link href="/Login" style={{ fontWeight: 700 }} className={styles.link}> <FontAwesomeIcon icon={faArrowLeft} /> Back to Login</Typography.Link>
                            </Typography.Title>
                        </div>
                    </Col>
                </Row>
            </div>
        </>
    );
};

export default ResetPasswordConfirm;
